import B2BUserModel from "src/models/B2BUserModel"
import { fetchB2BAgentUser } from "../AgentManagerSlice";

export const convertToB2BUser = (results) =>{
    const b2bUserModelInstance = new B2BUserModel(results);
    const convertToPlainObject = {
        B2BbUsers: b2bUserModelInstance.B2BbUsers,
    };
    return convertToPlainObject;
}

export const fetchB2BAgentUsers = (instance, accounts, filter = `users/any()`, top = 100) => {
    return async (dispatch) => {
        try {
            const response = await dispatch(
                fetchB2BAgentUser(instance, accounts, {
                    filter,
                    top,
                    select: `id,name,systemId`,
                    expand: `users($select=id,firstName,lastName,displayName,email,phoneNumber)`,
                })
            );

            if (!response.length) throw new Error("No B2B users available.");

            return response;
        } catch (error) {
            throw error;
        }
    };
};